import React, { useState } from "react";

import { Popper, Paper, ClickAwayListener } from "@mui/material";
import classnames from "classnames";

function FilterControls({
  reset,
  set,
  children,
  disabled,
}: {
  reset?: () => void;
  children: React.ReactNode;
  set: () => void;
  disabled?: boolean;
}) {
  return (
    <div className="main-dropdown__menu-controls">
      {children}
      {!!reset && (
        <button
          className="discard rounded-btn rounded-btn--grey hidden-md-down"
          onClick={reset}
        >
          Reset
        </button>
      )}
      <button
        type="button"
        className={`submit rounded-btn rounded-btn--blue ${
          disabled && "rounded-btn--disabled"
        }`}
        onClick={set}
        disabled={disabled}
      >
        Apply
      </button>
    </div>
  );
}

function FilterContent({
  children,
  reset,
  set,
  disabled,
  menuClass,
  width,
  minWidth,
  maxWidth,
  additionalControls,
  onClose,
}: {
  children: React.ReactNode;
  reset?: () => void;
  set: () => void;
  disabled?: boolean;
  menuClass: string;
  width?: string | number;
  minWidth?: string | number;
  maxWidth?: string | number;
  additionalControls?: React.ReactNode;
  onClose: () => void;
}) {
  return (
    <div
      className={classnames(
        "main-dropdown__menu",
        "main-dropdown__menu--indents",
        menuClass
      )}
      style={{ width, minWidth, maxWidth }}
    >
      {children}
      <FilterControls
        reset={reset}
        set={() => {
          set();
          onClose();
        }}
        disabled={disabled}
      >
        {additionalControls}
      </FilterControls>
    </div>
  );
}

export function FilterInterface({
  children,
  count,
  label,
  reset,
  set,
  disabled,
  menuClass,
  width,
  minWidth,
  maxWidth,
  additionalControls,
}: {
  children: React.ReactNode;
  additionalControls?: React.ReactNode;
  count: number;
  label: string;
  menuClass: string;
  reset?: () => void;
  set: () => void;
  disabled?: boolean;
  width?: string | number;
  minWidth?: string | number;
  maxWidth?: string | number;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        className="main-dropdown"
        data-cy={`${label}-filter-dropdown`}
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <div className="main-dropdown__placeholder">
          <div className="main-dropdown__placeholder-text">{label}</div>

          {count ? (
            <span className="main-dropdown__counter">{count}</span>
          ) : null}

          <i className="main-dropdown__arrow hidden-md-down icon icon-arrow" />
        </div>
      </div>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        style={{ zIndex: 100 }}
        disablePortal={false}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper elevation={8}>
            <FilterContent
              menuClass={menuClass}
              width={width}
              minWidth={minWidth}
              maxWidth={maxWidth}
              reset={reset}
              set={set}
              disabled={disabled}
              additionalControls={additionalControls}
              onClose={handleClose}
            >
              {children}
            </FilterContent>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
}
